<div
  class="habit"
  data-test-id="habit"
  [ngClass]="{ 'habit--empty': habit.strikes === 0 }"
  (tap)="emitHabitTap()"
  (press)="emitHabitPress()"
>
  <div class="habit__name">
    {{ habit.id }}
  </div>
  <div class="habit__strike" *ngIf="showStrikes">{{ habit.strikes }}</div>
  <div class="habit__option">
    <div
      class="habit__option__close"
      data-test-id="habit-delete-button"
      (click)="emitDelete()"
    >
      X
    </div>
  </div>
</div>
